module.exports = __webpack_public_path__ + "img/bz.b3950209.png";